import { forwardRef } from 'react';
import FormHeader from './FormHeader';

const FormLayout = forwardRef(({ title, children, onSubmit }, ref) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-primary-light px-2 py-8">
      <div className="w-full max-w-xl bg-white p-0 rounded-2xl shadow-xl overflow-hidden relative">
        <FormHeader title={title} />
        <form
          ref={ref}
          className="w-full px-6 py-8 md:px-10 md:py-10 flex flex-col gap-4"
          onSubmit={onSubmit}
          noValidate
        >
          {children}
        </form>
      </div>
    </div>
  );
});

FormLayout.displayName = 'FormLayout';

export default FormLayout;